<template>
 <v-container fluid fill-height class="weaver-hero" style="max-height: 100vh;">
    <v-container class="hero-container">
    </v-container>
 </v-container>
</template>

<script>
export default {
    name: 'WeaverHero'
};
</script>

<style scoped>
.weaver-hero {
    background: #222222;
    font-family: Helios;
}
.hero-container {
    background: url('~@/assets/images/weaversquare.png') center center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    font-family: Helios;
}
@font-face {
  font-family: "Helios Regular";
  src: url("~@/assets/fonts/helios_regular.otf") format("otf");
}
</style>